export default __webpack_public_path__ + "static/media/prompt_vector3.73a15114.png";